import clsx from 'clsx';
import { ReactElement } from 'react';

interface LoadingGradientProps {
  className?: string;
}

export const LoadingGradient = ({
  className,
}: LoadingGradientProps): ReactElement => {
  return (
    <div
      className={clsx(
        'relative overflow-x-hidden',
        'before:absolute before:inset-0 before:-translate-x-full before:animate-slide before:bg-gradient-to-r',
        'bg-primary-50 before:from-primary-50 before:via-white/50 before:to-primary-50',
        'mix-blend-multiply',
        className,
      )}
    />
  );
};
